<p-dataView [value]="data.results" [paginator]="true" [alwaysShowPaginator]="false" [rows]="pageSize" [lazy]="true"
  (onLazyLoad)="loadData($event)" [totalRecords]="totalRecords" emptyMessage="Nessun documento trovato">
  <ng-template pTemplate="list">
    @for (result of data.results; track $index) {
    <div class="col-12">
      <div class="result-details">
        <div class="grid ft-result">
          <div class="posizione">
            <app-position-value [posizione]="result.data.posizioneTree" [breadcrumb]="true"></app-position-value>
          </div>
          @if (!result.data.posizioneTree[0].chiuso) {
          <ng-container *hasClaim="GassClaims.DocModifica">
            <button pButton type="button" icon="fas fa-file" class="nuovo-documento"
              title="Nuovo documento in questa posizione"
              (click)="selectedDocument(result.data.posizioneTree)"></button>
          </ng-container>
          }
          <div class="d-flex-align">
            <div class="col-8 link">
              <img class="arrivo-icon" title="{{result.data.arrivo ? 'In arrivo' : 'In partenza'}}"
                [alt]="result.data.arrivo ? 'In arrivo' : 'In partenza'" [src]="getImgArrivo(result.data.arrivo)">

              <a routerLink="{{'/visualizza/' + result.data.documentoId}}" [innerHTML]="result.data.protocollo + ' - ' +
                (result.data.oggetto | highlight:searchTerm)"></a>

              @if (result.data.copiePer?.length) {
              <p-button title="Copie" [label]="''+ result.data.copiePer?.length" [rounded]="true" severity="info"
                styleClass="vertical-align-middle ml-2 text-xs"
                (onClick)="onShowCopyDialog(result.data.protocollo,result.data.copiePer)" />
              }
            </div>
            @if (items[result.data.documentoId]?.length) {
            <div class="save-btn">
              <p-splitButton class="download" label="" icon="pi pi-save"
                (onClick)="checkActionAllegato(items[result.data.documentoId][0].state?.allegato)"
                [model]="items[result.data.documentoId]" appendTo="body"
                [menuStyle]="{'word-break': 'break-word'}"></p-splitButton>
            </div>
            }
          </div>

          @if (result.data.textHighlight || isNoteHighligthed(result.data.note)) {
          <div class="col-12 documento-label">
            <b>Estratto: </b>
            <span [innerHTML]="getEstratto(result.data)"></span>
          </div>
          }
          <div class="col-6 documento-label" title="Data del documento"><b>Data:
            </b><span>{{result.data.dataDocumento | date:'longDate':'+0100':'it'}}</span>
          </div>
          @if (result.data.arrivo) {
          <div class="col-6 documento-label"><b>Mittente: </b>
            <span>{{result.data.mittente}}</span>
          </div>
          } @else {
          <div class="col-6 documento-label"><b>Destinatari: </b>
            <span>{{result.data.destinatari?.join(', ')}}</span>
          </div>
          }
          <div class="col-6 documento-label"><b>Stato: </b>
            <span>{{formatStato(result.data)}}</span>
          </div>
          @if (result.data.arrivo) {
          <div class="col-6 documento-label"><b>Protocollo Mittente: </b>
            <span [innerHTML]="result.data.protocolloMittente | highlight :searchTerm"></span>
          </div>
          }
          <div class="col-12 documento-label"><b>Note: </b>
            <span [innerHTML]="result.data.note"></span>
          </div>
        </div>
      </div>
    </div>
    }
  </ng-template>
</p-dataView>

<app-visualizza-copiaper-dialog [visible]="showCopyDialog" [protocollo]="selectedProtocol" [copie]="selectedCopies"
  (hide)="onHideCopyDialog()" />